import React, { useCallback, useEffect , useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import PageTitle from "../../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteCallLogsData, getCallLogsList, updateCallLogsStatusData } from "../../../redux/actions/CallLogsActions";
import RoundedPagination from "../../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../../redux/actions/AuthActions";
import useDebounce from "../../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from "../../../util/generalUtills";
import Preloader from "../../../Components/Preloader";
import CallLogsDetails from "../../../Components/DetailsTable/CallLogsDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import AddCallLogs from "../../../Components/FormComponent/AddCallLogs";

const Dashboard = () => {
  const { t } = useTranslation();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showCallDetailsModal, setShowCallDetailsModal] = useState(false);
  const [editCallLogsId, setEditCallLogsId] = useState(null);
  const [editCallLogsData, setEditCallLogsData] = useState([]);
  const {
    AuthReducer: { auth,errors,loading },
    callLogsReducer: {
      callLogsPermissions,
      callLogsLists,
      loadingCallLogs,
      errorsCallLogs,
      callLogsCount,
      changedCallLogsStatus,
    },
  } = useSelector((callLogs) => callLogs);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  
  const hideModel = () => {
    setShowModal(false);
    setEditCallLogsId(null);
    dispatch(getCallLogsList(auth.token, paginate, page, search, sort));
  };

  const hideCallDetailsModel = () => {
    setShowCallDetailsModal(false);
    setEditCallLogsData([]);
  };
  
  const fetchCallLogsList = useCallback(() => {
    if (auth?.token) {
      dispatch(getCallLogsList(auth.token, paginate, page, search, sort));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchCallLogsList, 500, [auth, paginate, page, search, sort]);

  useEffect(() => {
    if(errors)
    {
      if(errors?.status==401)
      {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  },[errors])



  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? callLogsCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleDeleteRequest = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, delete it!",
    })
    .then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteCallLogsData(auth?.token,id))
      }
    });
  };

  const handleStatusChangeRequest = (id, newStatus) => {
    swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${newStatus}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateCallLogsStatusData(auth.token, id, newStatus));
      }
    });
  };


  useEffect(() => {
    //console.log(changedCallLogsStatus);
    if(changedCallLogsStatus?.status)
    {
      swal.fire({
        show: true,
        title: "Deleted!",
        text: changedCallLogsStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CITY_STATUS' });
      dispatch(getCallLogsList(auth?.token, paginate, page, search, sort));
    }
    else if(changedCallLogsStatus?.success)
    {
      swal.fire({
        show: true,
        title: "Great !",
        text: changedCallLogsStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CITY_STATUS' });
      dispatch(getCallLogsList(auth?.token, paginate, page, search, sort));
    }
  },[changedCallLogsStatus])


  useEffect(() => {
    console.log('editCallLogsData',editCallLogsData);
  },[editCallLogsData]);

  useEffect(() => {
    document.title = `Call Logs :: ${auth?.generalSettings?.title}`;
  }, []);
  
  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Call Logs"), path: "/CallLogs", active: true },
        ]}
        title={t("Call Logs")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    <div className="d-flex align-items-center">
                    {(callLogsPermissions?.filter ) && (<>
                      <input
                        type="search"
                        placeholder="Search..."
                        className="form-control ms-1"
                        autoComplete="off"
                        value={search}
                        onChange={handleSearchChange}
                      />
                      </>)}
                      
                    </div>
                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                      {(callLogsPermissions?.add ) && (<>
                        <Button variant="success" onClick={() => {
                          setShowModal(true)
                          setEditCallLogsId(null)
                        }} >
                          <i className="mdi mdi-clipboard-plus-outline me-1"></i>Add
                        </Button>
                      </>)}
                      {(callLogsPermissions?.print ) && (<>
                        <Button variant="dark">
                          <i className="mdi mdi-printer me-1"></i>Print
                        </Button>
                      </>)}
                      {(callLogsPermissions?.excel ) && (<>
                        <Button variant="info">
                          <i className="mdi mdi-file-excel me-1"></i>Excel
                        </Button>
                      </>)}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{overflowY:'auto',maxHeight:'500px',border: "1px solid #dee2e6"}}>
                <Table className="mb-0 table-bordered"
                  size="sm"
                  striped
                  responsive
                  >
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>#</th>
                      <th>User</th>
                      <th>Status</th>
                      <th>Remark</th>
                      <th>Create By</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {callLogsLists.length === 0 ? (
                    <tr>
                      <td colSpan="12">No data found</td>
                    </tr>
                  ) : (<>
                    {callLogsLists?.map?.((item, index) => {
                      return (
                        <tr key={item.id}>
                          <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                          <td>{item?.request_idCallLogs?.name}<br/>({item?.request_idCallLogs?.adminUserType?.name})</td>
                          <td>{item?.request_status === "Complete" ? <Badge className={"bg-success"}>{item?.request_status}</Badge> : <><Badge className={"bg-danger"}>{item?.request_status}</Badge></>}</td>
                          <td>{item?.received_log}</td>
                          <td>{item?.request_idCallLogs?.name}<br/>({item?.request_idCallLogs?.adminUserType?.name})</td>
                          <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                          {(callLogsPermissions?.edit || callLogsPermissions?.delete) && (<>
                            <td>
                              {(item?.call_history!=null) && (<>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-created-at">
                                      Call Details
                                    </Tooltip>
                                  }
                                >
                                <Link 
                                  to="#" 
                                  className="action-icon text-success" 
                                  onClick={() => {
                                    setShowCallDetailsModal(true)
                                    setEditCallLogsData(JSON.parse(item?.call_history))
                                  }}>
                                  {" "}
                                  <i className="mdi mdi-eye"></i>
                                </Link>
                                </OverlayTrigger>
                              </>)}
                              
                              {(callLogsPermissions?.delete) && (<>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-created-at">
                                      Delete
                                    </Tooltip>
                                  }
                                >
                                <Link to="#" className="action-icon text-danger" onClick={() => handleDeleteRequest(item?.id)} >
                                  {" "}
                                  <i className="mdi mdi-delete"></i>
                                </Link>
                                </OverlayTrigger>
                              </>)}
                            </td>
                          </>)}
                          
                        </tr>
                      );
                    })}</>
                  )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(callLogsCount / paginate)}</strong> </span>
                <RoundedPagination currentPage={page} totalPages={Math.ceil(callLogsCount / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)}/>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <AddCallLogs show={showModal} onHide={() => hideModel()} editId={editCallLogsId}  />
      <CallLogsDetails show={showCallDetailsModal} onHide={() => hideCallDetailsModel()} tableData={editCallLogsData}  />

      
      {loadingCallLogs && (<Preloader/>)}
    </>
  );
};

export default Dashboard;
